export default {
  'accountandsettings.menuMap.basic': '基本设置',
  'accountandsettings.menuMap.security': '安全设置',
  'accountandsettings.menuMap.binding': '账号绑定',
  'accountandsettings.menuMap.notification': '新消息通知',
  'accountandsettings.basic.avatar': '头像',
  'accountandsettings.basic.change-avatar': '更换头像',
  'accountandsettings.basic.email': '邮箱',
  'accountandsettings.basic.email-message': '请输入您的邮箱!',
  'accountandsettings.basic.nickname': '昵称',
  'accountandsettings.basic.nickname-message': '请输入您的昵称!',
  'accountandsettings.basic.profile': '个人简介',
  'accountandsettings.basic.profile-message': '请输入个人简介!',
  'accountandsettings.basic.profile-placeholder': '个人简介',
  'accountandsettings.basic.country': '国家/地区',
  'accountandsettings.basic.country-message': '请输入您的国家或地区!',
  'accountandsettings.basic.geographic': '所在省市',
  'accountandsettings.basic.geographic-message': '请输入您的所在省市!',
  'accountandsettings.basic.address': '街道地址',
  'accountandsettings.basic.address-message': '请输入您的街道地址!',
  'accountandsettings.basic.phone': '联系电话',
  'accountandsettings.basic.phone-message': '请输入您的联系电话!',
  'accountandsettings.basic.update': '更新基本信息',
  'accountandsettings.basic.update.success': '更新基本信息成功',
  'accountandsettings.security.strong': '强',
  'accountandsettings.security.medium': '中',
  'accountandsettings.security.weak': '弱',
  'accountandsettings.security.password': '账户密码',
  'accountandsettings.security.password-description': '当前密码强度：',
  'accountandsettings.security.phone': '密保手机',
  'accountandsettings.security.phone-description': '已绑定手机：',
  'accountandsettings.security.question': '密保问题',
  'accountandsettings.security.question-description': '未设置密保问题，密保问题可有效保护账户安全',
  'accountandsettings.security.email': '备用邮箱',
  'accountandsettings.security.email-description': '已绑定邮箱：',
  'accountandsettings.security.mfa': 'MFA 设备',
  'accountandsettings.security.mfa-description': '未绑定 MFA 设备，绑定后，可以进行二次确认',
  'accountandsettings.security.modify': '修改',
  'accountandsettings.security.set': '设置',
  'accountandsettings.security.bind': '绑定',
  'accountandsettings.binding.taobao': '绑定淘宝',
  'accountandsettings.binding.taobao-description': '当前未绑定淘宝账号',
  'accountandsettings.binding.alipay': '绑定支付宝',
  'accountandsettings.binding.alipay-description': '当前未绑定支付宝账号',
  'accountandsettings.binding.dingding': '绑定钉钉',
  'accountandsettings.binding.dingding-description': '当前未绑定钉钉账号',
  'accountandsettings.binding.bind': '绑定',
  'accountandsettings.notification.password': '账户密码',
  'accountandsettings.notification.password-description': '其他用户的消息将以站内信的形式通知',
  'accountandsettings.notification.messages': '系统消息',
  'accountandsettings.notification.messages-description': '系统消息将以站内信的形式通知',
  'accountandsettings.notification.todo': '待办任务',
  'accountandsettings.notification.todo-description': '待办任务将以站内信的形式通知',
  'accountandsettings.settings.open': '开',
  'accountandsettings.settings.close': '关',
};
